<template>
  <section class="w-screen h-screen absolute flex justify-center items-center z-50">
    <div id="modal modal-customer" class="modal absolute block bg-white dark:bg-dark-800 w-5/6 sm:w-9/12 md:w-5/12 max-w-lg shadow-md rounded-lg dark:shadow-dark-600"
        :class="{
        'animate__animated animate__zoomIn': showModal,
        'animate__animated animate__zoomOut': !showModal,
        }">
        <div id="modal-header" class="w-full bg-color-1 py-3 rounded-t-lg">
          <h5 class="text-white text-center font-bold text-xl">{{ isEdit ? 'Edit Tipe Kitchen Division' : 'Tambah Kitchen Division' }}</h5>
        </div>
        <div id="modal-body" class="p-5 space-y-4 max-h-[calc(100dvh-220px)] overflow-y-auto">
          <InputTextCustom v-model="typeName" id="type-name" label="Nama Tipe"
          placeholder="Masukkan nama tipe" input_class="w-full" :valid="validation.name.valid"
          :error-message="validation.name.message" />
          <InputTextCustom v-model="printerIP" id="printer-ip" label="IP Printer"
          placeholder="Masukkan IP printer" input_class="w-full" :valid="validation.printer_ip.valid"
          :error-message="validation.printer_ip.message" :hint="hint.printer_ip" />
        </div>
        <div class="modal-footer p-5">
          <div class="flex justify-center">
            <SubmitButton id="close" button_name="Close" button_class="mx-1 text-red-600 border-red-600 hover:text-white hover:bg-red-600" @click="closeModal"/>
            <SubmitButton id="submit" button_name="Submit" button_class="mx-1 bg-color-1 hover:bg-color-2 text-color-4" @click="submitKitchenDivision"/>
          </div>
        </div>
    </div>
  </section>
</template>

<script>
import InputTextCustom from '../form/InputTextCustom.vue';
import SubmitButton from '../form/SubmitButton.vue';
import { mapActions } from 'vuex';

export default {
  name: "ModalKitchenDivision",
  props: {
    kitchenDivision: {
      type: Object,
      default: null,
    }
  },
  components: {
    SubmitButton, InputTextCustom
  },
  data() {
    return {
      showModal: true,
      typeName: this.kitchenDivision ? this.kitchenDivision.name : '',
      printerIP: this.kitchenDivision ? this.kitchenDivision.printer_ip : '',
      isEdit: !!this.kitchenDivision,
      validation: {
        name: {
          valid: true,
          message: ''
        },
        printer_ip: {
          valid: true,
          message: ''
        }
      },
      hint: {
        printer_ip: ['Contoh: 237.84.2.178']
      },
      field: ['name', 'printer_ip'],
    }
  },
  watch: {
    kitchenDivision(newVal) {
      if (newVal) {
        this.typeName = newVal.name;
        this.printerIP = newVal.printer_ip;
        this.isEdit = true;
      } else {
        this.typeName = '';
        this.printerIP = '';
        this.isEdit = false;
      }
    }
  },
  methods: {
    ...mapActions('kitchen_divisions', ['createKitchenDivision', 'updateKitchenDivision']),
    closeModal() {
      this.showModal = false;
      setTimeout(() => {
        this.$emit('closeModal');
      }, 200); 
    },
    submitKitchenDivision() {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin menyimpan kitchen division?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.postKitchenDivision();
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan aksi simpan kitchen division', life: 3000 });
        }
      });
    },
    async postKitchenDivision() {
      try {
        const typeData = {
          name: this.typeName,
          printer_ip: this.printerIP
        };

        if(this.isEdit && this.kitchenDivision) {
          typeData.id = this.kitchenDivision.id;
          await this.updateKitchenDivision(typeData);
        }
        else {
          await this.createKitchenDivision(typeData);
        }

        this.closeModal();
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Kitchen division berhasil disimpan', life: 5000 });
      }
      catch (error) {
        console.error('Failed to save transaction type:', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
    },
    validationErrors(errorMessage) {
      for (let index = 0; index < this.field.length; index++) {
        this.validation[this.field[index]].valid = true;
        this.validation[this.field[index]].message = '';
      }

      errorMessage.forEach((error) => {
        if (this.validation[error.field]) {
          this.validation[error.field].valid = false;
          this.validation[error.field].message = error.message;
        }
      });
    }
  }
}
</script>
